import { ReactNode, CSSProperties } from 'react'

interface H2Props extends React.HTMLAttributes<HTMLHeadingElement> {
	cssVars?: Record<string, string>
	children: ReactNode
	className?: string
}

export const H2: React.FC<H2Props> = ({
	cssVars = {},
	children,
	className = '',
	style,
	...props
}) => {
	const inlineStyles: CSSProperties = {
		fontSize: cssVars['fontSize'] || undefined,
		fontWeight: cssVars['fontWeight'] || undefined,
		lineHeight: cssVars['lineHeight'] || undefined,
		fontFamily: cssVars['fontFamily'] || undefined,
		marginBottom: cssVars['marginBottom'] || undefined,
	}

	const mergedStyle = { ...inlineStyles, ...(style || {}) }
	const baseClasses = 'text-3xl font-semibold leading-6 mb-1'
	const composedClassName = [baseClasses, className].filter(Boolean).join(' ')

	return (
		<h2 style={mergedStyle} className={composedClassName} {...props}>
			{children}
		</h2>
	)
}
